import { ReactComponent as LogoSvg } from "../../../logo-solid-svg.svg";

export default function SolidLogo(props: { className?: string }) {
  return <LogoSvg className={props.className} />;
}
